import type { LatLng } from "@/map/types/map";
import type { TLocation } from "@/locations/types/location";

/**
 * Org-wide map pins need a coordinate per location, but `TLocation` carries no
 * lat/lng — only its machines. Derive a centroid by averaging the last known
 * GPS of every machine that has one. Returns `null` when no machine has GPS
 * (caller should skip the pin).
 */
export const getLocationCentroid = (location: TLocation): LatLng | null => {
  const points = (location.machines ?? [])
    .map((m) => m.last_gps)
    .filter(
      (g): g is NonNullable<typeof g> =>
        !!g && Number.isFinite(g.latitude) && Number.isFinite(g.longitude),
    );

  if (points.length === 0) return null;

  const lat = points.reduce((sum, g) => sum + g.latitude, 0) / points.length;
  const lng = points.reduce((sum, g) => sum + g.longitude, 0) / points.length;
  return { lat, lng };
};
